var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.418 19.7504H4.58464C4.07838 19.7504 3.66797 19.34 3.66797 18.8337V10.5837H0.917969L10.3847 1.97764C10.7343 1.6598 11.2683 1.6598 11.6179 1.97764L21.0846 10.5837H18.3346V18.8337C18.3346 19.34 17.9242 19.7504 17.418 19.7504ZM5.5013 17.9171H16.5013V8.89476L11.0013 3.89476L5.5013 8.89476V17.9171ZM11.0013 14.2504C9.73566 14.2504 8.70964 13.2244 8.70964 11.9587C8.70964 10.6931 9.73566 9.66708 11.0013 9.66708C12.2669 9.66708 13.293 10.6931 13.293 11.9587C13.293 13.2244 12.2669 14.2504 11.0013 14.2504Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.912bbee649d708a51fd839121bb991df.svg";
export { ForwardRef as ReactComponent };